import React, { useState, useEffect, useRef } from "react";
import apiClient from "../apiClient";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useShop } from '../context/ShopContext';
import { FaSpinner } from 'react-icons/fa';
import EmptyState from "./EmptyState";
import "./responsiveTable.css";
const Commission = () => {

    const [products, setProducts] = useState([]);
    const [amounts, setAmounts] = useState({});
    const [loading, setLoading] = useState(true);
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
    const inputRefs = useRef([]);
    const { shopId , companyId} = useShop();
    const [partyMasters, setPartyMasters] = useState([]);
    const [selectedParty, setSelectedParty] = useState("");
    const [selectedPartyId, setSelectedPartyId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
   




  const showToast = (message, type = "error") => {
                toast.dismiss(); 
              
                console.log("Toast Type:", type); 
              
                if (type.toLowerCase() === "error") {
                  toast.error(message);
                } else if (type.toLowerCase() === "success") {
                  toast.success(message);
                } else {
                  console.warn("Invalid toast type:", type);
                }
              };








    const fetchProducts = async () => {
        try {
            setLoading(true);
            const formattedDate = date ? new Date(date).toISOString() : null;
            if (!formattedDate) {
                throw new Error("Invalid date provided.");
            }
    
            const response = await apiClient.post(
                "/Liquor/GetCommissionSalesProduct",
                {
                    shopId: shopId,
                    typeId: "1",
                    stockDate: date || new Date().toISOString().split("T")[0],
                }
            );
    
            if (response.data?.code === 200 && Array.isArray(response.data.data)) {
                const formattedProducts = response.data.data.map(product => ({
                    id: product.id,
                    pName: product.pName,
                    packing: product.packing,
                    mrp: parseFloat(product.mrp) || 0,
                    actMrp: parseFloat(product.actMRP) || 0,
                    actMrpCommission: parseFloat(product.actMRPCommission) || 0,
                    totalSale: Math.round(parseFloat(product.salesToday) || 0),
                }));
    
                setProducts(formattedProducts);
    
                // Initialize amounts with commissionSale as empty and counterSale from totalSale
                const initialAmounts = formattedProducts.reduce((acc, product) => {
                    acc[product.id] = {
                        commissionSale: "",
                        counterSale: product.totalSale,
                    };
                    return acc;
                }, {});
    
                setAmounts(initialAmounts);
            } else {
                showToast(response.data?.message || "Failed to fetch products","error");
                setProducts([]);
            }
        } catch (error) {
            console.error("API Error:", error);
            showToast(error.response?.data?.message || "Error fetching products","error");
            setProducts([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (shopId) {
            fetchProducts();
        }
    }, [date, shopId]);




    const handleInputChange = (id, field, value) => {
        let product = products.find(p => p.id === id);

        setAmounts(prev => {
            let updatedAmount = { ...prev[id] };

            if (field === "commissionSale") {
                let commissionSale = value ? parseFloat(value) : 0;
                let totalSale = product.totalSale;

                if (commissionSale < 0) { showToast('Commission Sale cannot be negative', "error"); return prev; }
                if (commissionSale > totalSale) { showToast('Commission Sale cannot be greater than Total Sale', "error"); return prev; }

                updatedAmount.commissionSale = commissionSale;
                updatedAmount.counterSale = totalSale - commissionSale;

                // recalculate derived fields if value already entered
                const cv = parseFloat(updatedAmount.commissionValue) || 0;
                if (cv > 0) {
                    const saleBase = commissionSale * product.mrp;
                    const mrpBase  = commissionSale * product.actMrpCommission;
                    updatedAmount.commissionPercent    = saleBase > 0 ? ((cv / saleBase) * 100).toFixed(2) : "0.00";
                    updatedAmount.mrpCommissionPercent = mrpBase  > 0 ? ((cv / mrpBase)  * 100).toFixed(2) : "0.00";
                }
            }
            else if (field === "commissionValue") {
                let commissionValue = value ? parseFloat(value) : "";
                let commissionSale  = prev[id]?.commissionSale || 0;
                let maxCommissionValue = commissionSale * product.mrp;

                if (commissionValue < 0) {
                    showToast('Commission Value cannot be negative', "error");
                    updatedAmount.commissionValue = "";
                    updatedAmount.commissionPercent = "";
                    updatedAmount.mrpCommissionPercent = "";
                    return { ...prev, [id]: updatedAmount };
                }

                if (commissionValue > maxCommissionValue) {
                    showToast(`Commission Value cannot exceed ₹${maxCommissionValue}`, "error");
                    updatedAmount.commissionValue = "";
                    updatedAmount.commissionPercent = "";
                    updatedAmount.mrpCommissionPercent = "";
                    return { ...prev, [id]: updatedAmount };
                }

                updatedAmount.commissionValue = commissionValue;

                const saleBase = commissionSale * product.mrp;
                const mrpBase  = commissionSale * product.actMrpCommission;
                updatedAmount.commissionPercent    = saleBase > 0 ? ((commissionValue / saleBase) * 100).toFixed(2) : "0.00";
                updatedAmount.mrpCommissionPercent = mrpBase  > 0 ? ((commissionValue / mrpBase)  * 100).toFixed(2) : "0.00";
            }
            else if (field === "remark") {
                updatedAmount.remark = value;
            }

            return { ...prev, [id]: updatedAmount };
        });
    };
    
    
    
 const handleSubmit = async () => {
     
        if (!selectedPartyId) {
            showToast("Please select a party before submitting!", "error");
            return; // stop submission
        }
    
        try {
            setLoading(true);
    
            const dataToSubmit = products
                .map((product, index) => {
                    const commissionSale = parseFloat(amounts[product.id]?.commissionSale) || 0;
                    const commissionValue = parseFloat(amounts[product.id]?.commissionValue) || 0;
                    const remark = amounts[product.id]?.remark || "";
                    const rate = product.mrp; 
    
                    if (commissionSale === 0 && commissionValue === 0) {
                        return null; 
                    }
    
                    const totalSale = product.totalSale;
                    const counterSale = totalSale - commissionSale;
    
                    // Calculate ProductPerCommission (percentage)
                    let productPerCommission = 0;
                    if (rate > 0) {
                        productPerCommission = ((commissionValue / (commissionSale * product.mrp)) * 100).toFixed(2);
                    }
    
                    return {
                        Id: index + 1,
                        ProductId: product.id,
                        ShopId: shopId,
                        rate: parseFloat(rate.toFixed(2)), 
                        CommissionSale: parseFloat(commissionSale.toFixed(2)),
                        CounterSale: parseFloat(counterSale.toFixed(2)),
                        TotalSale: totalSale,
                        CommissionValue: parseFloat(commissionValue.toFixed(2)),
                        SaleDate: date || new Date().toISOString().split("T")[0], // Ensure valid date format
                        RectimeStamp: date || new Date().toISOString().split("T")[0], // Ensure valid date format
                        Remark: remark,
                        CommissionId: selectedPartyId,
                        ProductPerCommission: productPerCommission,
                    };
                })
                .filter(item => item !== null);
    
            if (dataToSubmit.length === 0) {
                showToast("No valid data to submit!", "error");
                setLoading(false);
                return;
            }
    
            const response = await apiClient.post(
                "/Liquor/SaveCommissionData",
                dataToSubmit
            );
    
            if (response.data.code === 200) {
                showToast("Data submitted successfully!", "success");
                setAmounts({});
                fetchProducts();
            } else {
                showToast("Failed to submit data", "error");
            }
        } catch (error) {
            showToast("Error submitting data", "error");
            console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };
    
    
    
    

    
    

    const isSubmitEnabled = Object.values(amounts).some(amount => parseFloat(amount?.commissionSale) > 0);
    const totalCommissionValue = Object.values(amounts).reduce((sum, item) => {
        const value = parseFloat(item?.commissionValue) || 0;
        return sum + value;
      }, 0);


      const totalSale = products.reduce((sum, product) => sum + product.totalSale, 0);

      const totalActMrpCommission = products.reduce((sum, product) => sum + (product.actMrpCommission || 0), 0);

       const totalCommissionSaleRate = products.reduce((sum, product) => {
       const commissionSale = amounts[product.id]?.commissionSale || 0;
       return sum + (commissionSale * product.mrp);
        }, 0);
      

       const Netsale = totalCommissionSaleRate-totalCommissionValue



    const netPercentage = totalCommissionSaleRate > 0
              ? ((totalCommissionValue / totalCommissionSaleRate) * 100).toFixed(2)
                  : "0.00";

    const totalActMrpBase = products.reduce((sum, product) => {
        const commissionSale = parseFloat(amounts[product.id]?.commissionSale) || 0;
        return sum + (commissionSale * (product.actMrpCommission || 0));
    }, 0);

    const totalActMrpPercent = totalActMrpBase > 0
        ? ((totalCommissionValue / totalActMrpBase) * 100).toFixed(2)
        : "0.00";


    useEffect(() => {
        const fetchPartyMasters = async () => {
          try {
            const response = await apiClient.post(
              '/Liquor/GetCommissionHead',
              { companyId, typeId: 1 }
            );
            const options = response.data?.data?.map((item) => ({
              id: item.id,
              label: item.name,
            }));
            setPartyMasters(options);
          } catch (err) {
            console.error('Error fetching party master options:', err);
            showToast('Failed to load Commission Head.', "error");
          }
        };
        fetchPartyMasters();
      }, []);






    return (
      <div className="p-4">
        <ToastContainer />

        {/* ── Filters ── */}
        <div className="form-group d-flex gap-5 mb-4 flex-wrap">
          <div className="col-lg-3 col-6">
            <label className="form-label">Date:</label>
            <input
              type="date"
              className="form-control"
              value={date}
              max={new Date().toISOString().split("T")[0]}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <div className="col-lg-3 col-6">
            <label className="form-label">English Commission Head</label>
            <select
              className="form-control"
              value={selectedPartyId}
              onChange={(e) => setSelectedPartyId(e.target.value)}
            >
              <option value="">Select Head</option>
              {partyMasters.map((party) => (
                <option key={party.id} value={party.id}>{party.label}</option>
              ))}
            </select>
          </div>
          <div className="col-lg-3 col-6">
            <label className="form-label">Search Product</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search product"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* ── Table ── */}
        <div className="table-responsive h-700px entry-desktop" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
          {loading ? (
            <div className="loader-container">
              <FaSpinner className="spinner-icon" />
            </div>
          ) : products.length > 0 ? (
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Product Name</th>
                  <th>Rate</th>
                  <th>Variant</th>
                  <th>Total Sale</th>
                  <th>ACT MRP</th>
                  <th>Commission Sale</th>
                  <th>Counter Sale</th>
                  <th>Commission Value</th>
                  <th>Sale Rate %</th>
                  <th>MRP Comm %</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {products
                  .filter((p) => p.pName.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map((product, index) => (
                    <tr key={product.id}>
                      <td>{index + 1}</td>
                      <td>{product.pName}</td>
                      <td>{product.mrp}</td>
                      <td>{product.packing}</td>
                      <td>{product.totalSale}</td>
                      <td style={{ fontWeight: 600, color: product.actMrpCommission > 0 ? "#10B981" : "inherit" }}>
                        {product.actMrpCommission > 0 ? `₹${product.actMrpCommission.toFixed(2)}` : "-"}
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={amounts[product.id]?.commissionSale || ""}
                          onChange={(e) => handleInputChange(product.id, "commissionSale", e.target.value)}
                        />
                      </td>
                      <td>{amounts[product.id]?.commissionSale ? amounts[product.id]?.counterSale : ""}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={amounts[product.id]?.commissionValue ?? ""}
                          onChange={(e) => handleInputChange(product.id, "commissionValue", e.target.value)}
                        />
                      </td>
                      <td style={{ color: "#6366F1", fontWeight: 600 }}>
                        {amounts[product.id]?.commissionPercent ? `${amounts[product.id].commissionPercent}%` : ""}
                      </td>
                      <td style={{ color: "#F59E0B", fontWeight: 600 }}>
                        {amounts[product.id]?.mrpCommissionPercent ? `${amounts[product.id].mrpCommissionPercent}%` : ""}
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={amounts[product.id]?.remark || ""}
                          onChange={(e) => handleInputChange(product.id, "remark", e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <EmptyState />
          )}
        </div>

        {/* Mobile: product commission cards */}
        <div className="entry-mobile">
          {loading ? (
            <div className="loader-container"><FaSpinner className="spinner-icon" /></div>
          ) : products.length === 0 ? (
            <EmptyState />
          ) : (
            products
              .filter((p) => p.pName.toLowerCase().includes(searchQuery.toLowerCase()))
              .map((product, index) => (
                <div key={product.id} className="ef-card">
                  <div className="ef-card-header">
                    <span className="ef-card-title">{product.pName}</span>
                    <span className="ef-card-badge">{product.packing}</span>
                  </div>
                  <div className="ef-card-body">
                    <div className="ef-info-row">
                      <div className="ef-info-pill">
                        <span className="ef-info-pill-label">Rate</span>
                        <span className="ef-info-pill-value">{product.mrp}</span>
                      </div>
                      <div className="ef-info-pill">
                        <span className="ef-info-pill-label">Total Sale</span>
                        <span className="ef-info-pill-value">{product.totalSale}</span>
                      </div>
                      {product.actMrpCommission > 0 && (
                        <div className="ef-info-pill">
                          <span className="ef-info-pill-label">ACT MRP</span>
                          <span className="ef-info-pill-value" style={{ color: "#10B981" }}>₹{product.actMrpCommission.toFixed(2)}</span>
                        </div>
                      )}
                    </div>
                    <div className="ef-field">
                      <span className="ef-field-label">Commission Sale</span>
                      <input
                        type="text"
                        className="form-control"
                        value={amounts[product.id]?.commissionSale || ""}
                        onChange={(e) => handleInputChange(product.id, "commissionSale", e.target.value)}
                        placeholder="Enter Commission Sale"
                      />
                    </div>
                    {amounts[product.id]?.commissionSale ? (
                      <div className="ef-field">
                        <span className="ef-field-label">Counter Sale</span>
                        <div className="ef-field-display">{amounts[product.id]?.counterSale}</div>
                      </div>
                    ) : null}
                    <div className="ef-field">
                      <span className="ef-field-label">Commission Value</span>
                      <input
                        type="text"
                        className="form-control"
                        value={amounts[product.id]?.commissionValue ?? ""}
                        onChange={(e) => handleInputChange(product.id, "commissionValue", e.target.value)}
                        placeholder="Enter Commission Value"
                      />
                    </div>
                    {amounts[product.id]?.commissionPercent ? (
                      <div className="ef-field">
                        <span className="ef-field-label">Sale Rate %</span>
                        <div className="ef-field-display" style={{ color: "#6366F1", fontWeight: 700 }}>{amounts[product.id]?.commissionPercent}%</div>
                      </div>
                    ) : null}
                    {amounts[product.id]?.mrpCommissionPercent ? (
                      <div className="ef-field">
                        <span className="ef-field-label">MRP Comm %</span>
                        <div className="ef-field-display" style={{ color: "#F59E0B", fontWeight: 700 }}>{amounts[product.id]?.mrpCommissionPercent}%</div>
                      </div>
                    ) : null}
                    <div className="ef-field">
                      <span className="ef-field-label">Remark</span>
                      <input
                        type="text"
                        className="form-control"
                        value={amounts[product.id]?.remark || ""}
                        onChange={(e) => handleInputChange(product.id, "remark", e.target.value)}
                        placeholder="Enter Remark"
                      />
                    </div>
                  </div>
                </div>
              ))
          )}
        </div>

        {/* ── Summary + Submit bar ── */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          flexWrap: "wrap", gap: 12, marginTop: 16,
          padding: "14px 18px",
          background: "linear-gradient(135deg, #0f172a 0%, #1e2a45 100%)",
          borderRadius: 12,
          boxShadow: "0 4px 16px rgba(99,102,241,0.15)",
        }}>
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap", alignItems: "center" }}>
            {[
              { label: "Commission Value", value: `₹${totalCommissionValue.toFixed(2)}`, color: "#6366F1" },
              { label: "Sale Amount", value: `₹${totalCommissionSaleRate.toFixed(2)}`, color: "#10B981" },
              { label: "Net Sale", value: `₹${Netsale.toFixed(2)}`, color: Netsale >= 0 ? "#10B981" : "#EF4444" },
              { label: "Commission %", value: `${netPercentage}%`, color: "#F59E0B" },
              { label: "ACT MRP Comm %", value: `${totalActMrpPercent}%`, color: "#A78BFA" },
            ].map((item, i, arr) => (
              <React.Fragment key={item.label}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: item.color, flexShrink: 0 }} />
                  <span style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{item.label}</span>
                  <span style={{ fontSize: 14, fontWeight: 800, color: item.color }}>{item.value}</span>
                </div>
                {i < arr.length - 1 && <div style={{ width: 1, height: 24, background: "rgba(255,255,255,0.1)" }} />}
              </React.Fragment>
            ))}
          </div>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={!isSubmitEnabled || loading}
            style={{ minWidth: 110, fontWeight: 700 }}
          >
            {loading ? "Submitting…" : "✓ Submit"}
          </button>
        </div>
      </div>
    )
};

export default Commission;
